import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AllTicketsHeader from './AllTicketsHeader';
import { columnsAlumnosMonths } from 'components/dashboards/support-desk/unsolved-tickets/TicketsLayout';
import { dataCuotas } from 'data/apiConection.js/dataCuotas.js';

const TableCuotasMonth = () => {
  const [ cuotas , setCuotas ] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cu = await dataCuotas();
        setCuotas(cu);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    fetchData();
  }, []); 


  const columns = columnsAlumnosMonths();

  return (
    <Row
      className="gx-4 mx-0"
      style={{
        height: '100vh',
        width: '100%',
        marginLeft: '250px',
        padding: '20px', 
      }}
    >
      {cuotas && (
        <Col style={{ height: '100%' }}>
          <AdvanceTableWrapper
            columns={columns}
            data={cuotas}
            selection
            selectionColumnWidth={52}
            sortable
            pagination
            perPage={100}
            rowCount={cuotas.length}
          >
            <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Card.Header className="border-bottom border-200 px-0">
                <AllTicketsHeader title="Cuotas" table layout="table-view" />
              </Card.Header>
              <Card.Body className="p-3" style={{ flexGrow: 1, overflowY: 'auto' }}>
                <AdvanceTable
                  table
                  headerClassName="bg-light text-800 align-middle"
                  rowClassName="btn-reveal-trigger align-middle"
                  tableProps={{
                    size: 'sm',
                    className: 'fs--1 mb-0 w-100 h-100',
                  }}
                />
              </Card.Body>
              <Card.Footer>
                <AdvanceTablePagination table />
              </Card.Footer>
            </Card>
          </AdvanceTableWrapper>
        </Col>
      )}
    </Row>
  );
};

export default TableCuotasMonth;
